import Api from "@/services/Api";

export default {
    async getUnits() {
        var units = []
        await Api(true).post("unit/list", {})
        .then(r => {
            units = r.data.map(e => {
                e.label = e.name
                return e
            })
        })
        return units
    },

    async createUnit(unit) {
        const r = await Api(true).post("unit/create", unit);
        return r.data;
    },

    async editUnit(unit) {
        const r = await Api(true).post("unit/edit", unit);
        return r.data;
    }
}